export default "__VITE_ASSET__Bc4XB8vT__"